import React from 'react';
import { useTranslation } from 'react-i18next';
import { List } from 'semantic-ui-react';
import * as Yup from 'yup';
import { Form as SemanticForm } from 'semantic-ui-react';
import { Form, Dropdown, Checkbox } from '../../../../../components';


const schema = Yup.object().shape({
  isContract: Yup.boolean(),
  classification: Yup.string(),
  category: Yup.string()
});

const classificationOptions = [
  { key: 1, value: 'A+', text: 'A+' },
  { key: 2, value: 'A', text: 'A' },
  { key: 3, value: 'B', text: 'B' },
  { key: 4, value: 'C', text: 'C' }
]

const categoryOptions = [
  { key: 1, value: "CONDO", text: "Condomínio" },
  { key: 2, value: "HOTEL", text: "Hotel" },
  { key: 3, value: "RESORT", text: "Resort" },
  { key: 4, value: "CORPORATE", text: "Corporativo" },
  { key: 5, value: "SCHOOL", text: "Escola" },
  { key: 6, value: "SHOPPING", text: "Shopping" },
  { key: 7, value: "OTHER", text: "Outros" }
]

const General = ({
  building,
  updateClassification,
  updateIsContract,
  updateCategory
}) => {
  const { t } = useTranslation();
  const { address } = building.location;
  const fullAddress = `${address.street}, ${address.number}, ${address.neighborhood}, ${address.city} - ${address.state}`;

  const onChangeIsContract = (attribute) =>
    (_, { checked }) => {
      updateIsContract(checked);
    };

  const onChangeClassification = (_, { value }) => {
    updateClassification(value)
  };

  const onChangeCategory = (_, { value }) => {
    updateCategory(value)
  }

  return (
    <Form initialData={building} schema={schema}>
      <SemanticForm.Group widths='equal'>
        <Checkbox
          label={t('BUILDINGS.NEW.GENERAL_STEP.IS_CONTRACT.LABEL')}
          name="isContract"
          toggle
          checked={building.isContract}
          onClick={onChangeIsContract('building.isContract')}
        />
        <Dropdown
          fluid
          selection
          name='building.classification'
          label={t('BUILDINGS.NEW.GENERAL_STEP.CLASSIFICATIONS.LABEL')}
          placeholder={t('BUILDINGS.NEW.GENERAL_STEP.CLASSIFICATIONS.PLACEHOLDER')}
          value={building?.classification}
          options={classificationOptions}
          onChange={onChangeClassification}
        />
        {building?.company?.name === "Edifica" ?
          <Dropdown
            fluid
            selection
            name='category'
            label={t('BUILDINGS.NEW.GENERAL_STEP.CATEGORY.LABEL')}
            placeholder={t('BUILDINGS.NEW.GENERAL_STEP.CATEGORY.PLACEHOLDER')}
            options={categoryOptions}
            onChange={onChangeCategory}
          />
          :
          <></>
        }
      </SemanticForm.Group>
      <List divided>
        <List.Item>
          <List.Header>{t('BUILDINGS.DETAILS.GENERAL.COMPANY')}</List.Header>
          {building.company.name}
        </List.Item>
        {((building.documents && building.documents.cnpj) || building.cnpj) && (
          <List.Item>
            <List.Header>{t('BUILDINGS.DETAILS.GENERAL.CNPJ')}</List.Header>
            {building.documents ? building.documents.cnpj : building.cnpj}
          </List.Item>
        )}
        <List.Item>
          <List.Header>{t('BUILDINGS.DETAILS.GENERAL.NAME')}</List.Header>
          {building.name}
        </List.Item>
        <List.Item>
          <List.Header>{t('BUILDINGS.DETAILS.GENERAL.TIME_ZONE')}</List.Header>
          {building.timezone}
        </List.Item>
        <List.Item>
          <List.Header>{t('BUILDINGS.DETAILS.GENERAL.ADDRESS')}</List.Header>
          {fullAddress}
        </List.Item>
        <List.Item>
          <List.Header>{t('BUILDINGS.DETAILS.GENERAL.ORIENTATION')}</List.Header>
          {t(`GLOBAL.LABELS.${building.orientation}`)}
        </List.Item>
        <List.Item>
          <List.Header>{t('BUILDINGS.DETAILS.GENERAL.BLOCK_LABEL')}</List.Header>
          {t(`GLOBAL.LABELS.${building.labels.block}`)}
        </List.Item>
        <List.Item>
          <List.Header>{t('BUILDINGS.DETAILS.GENERAL.UNIT_LABEL')}</List.Header>
          {t(`GLOBAL.LABELS.${building.labels.unit}`)}
        </List.Item>
        <List.Item>
          <List.Header>{t('BUILDINGS.DETAILS.GENERAL.USER_LABEL')}</List.Header>
          {t(`GLOBAL.LABELS.${building.labels.user}`)}
        </List.Item>
        {/* <List.Item>
        <List.Header>{t('BUILDINGS.DETAILS.GENERAL.BLOCKS_AMOUNT')}</List.Header>
        {building.blocks.length}
      </List.Item>
      <List.Item>
        <List.Header>{t('BUILDINGS.DETAILS.GENERAL.UNITS_AMOUNT')}</List.Header>
        {building.units.length}
      </List.Item> */}
      </List>
    </Form>
  );
};

export default General;
